/**
 * @fileoverview Autocomplete Resource Item Template Module.
 * Provides a template function for rendering resource items in an autocomplete dropdown.
 */

/**
 * Generates HTML content for an individual resource item in an autocomplete dropdown.
 * This function creates a custom display format for each resource item, including an image,
 * title, excerpt, and formatted date.
 *
 * @param {Object} params - Parameters containing resource item data and the HTML function.
 * @param {Object} params.item - The individual resource item data to be rendered.
 * @param {Function} params.html - A tagged template literal from LitHTML or a similar library.
 * @returns {TemplateResult} - The HTML content for the autocomplete resource item.
 */
export const AutocompleteResourceItemTemplate = ({ item, html }) => {
    return html`
        <a href="${item.permalink}">
            <div class="flex flex-nowrap pr-[7px] md:p-[15px] bg-pearl-lighter">
                <div 
                        style="background-image: url('${item.featured_image}')" 
                        class="bg-center bg-no-repeat bg-cover flex items-center h-[90px] min-w-[90px] max-w-[90px] md:h-[168px] md:min-w-[168px] md:max-w-[168px] ${! item.featured_image ? 'bg-pxl-fossil-gray' : ''}">
                </div>
                <div class="flex flex-wrap items-space-between pl-5 font-sans leading-tight py-1 md:py-0">
                    <div class="text-mobile-regular md:text-body-large md:font-medium text-black w-ful mb-[25px] md:m-0">
                        ${item.post_title}
                    </div>
                    <div class="hidden md:block text-body-medium text-pxl-fossil-gray w-full">
                        ${item.post_excerpt}
                    </div>
                    <div class="text-mobile-small md:text-body-regular flex items-end w-full font-medium">
                        ${item.formattedDate}
                    </div>
                </div>
            </div>
        </a>`;
};
